// 22.01.19 - Controls the navigation structure with route.
import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Header from "../components/common/header";
import {
  DETAIL_PATH,
  HOME_PATH,
  INTRO_PATH,
  PRINT_PATH,
  SP_FORM_PATH,
  INCIDENT_DETAIL_PATH,
  ERROR_PATH,
  USERS_PATH,
  ACCESS_REQUEST_PATH,
  Dashboard_PATH,
  //UI_HOME,
} from "../constants/api";
import HomeContainer from "src/containers/home";
import IntroComponent from "src/components/intro";
import {
  withStyles,
  WithStyles,
  CssBaseline,
  Theme,
  createStyles,
} from "@material-ui/core";
import { headerStyles, toolbarStyles } from "src/styles/general";
import { FormWrapper } from "src/components/detail/form_wrapper";
import { ContentWrapper } from "src/components/common/content_wrapper";
import PrintPreviewComponent from "src/components/print";
import SpFormComponent from "src/components/detail/sp_form";
import authwrapper from "src/components/common/auth-wrapper";
import UserProfileComponent from "../components/user-profile";
import { getBuildDate } from "../utils";
import packageJson from "../../package.json";
import { useSelector } from "react-redux";
import ErrorComponent from "src/components/error";
import { Authentication } from "src/components/authentication";
import AccessRequestComponent from "src/components/access-request";
import PBIDashboardComponent from "src/components/pbi-dashboard";

type IndexProps = WithStyles<typeof joinedStyles>;

function RouterComponent(IndexProps: any) {
  const { classes } = IndexProps;

  const isAuthenticated = Authentication();

  const isUserAuthenticated = useSelector(
    (state: any) => state.userProfile.isAuthenticated
  );

  return (
    <React.Fragment>
      {isAuthenticated && isUserAuthenticated ? (
        <div className={classes.root}>
          <CssBaseline />
          <Route component={Header} />
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <ContentWrapper>
              <Switch>
                <Route
                  exact={true}
                  path={INTRO_PATH}
                  component={IntroComponent}
                />
                <Route
                  exact={true}
                  path={HOME_PATH}
                  component={HomeContainer}
                />
                <Route
                  exact={true}
                  path={[DETAIL_PATH, ":id", ":subform"].join("/")}
                  component={FormWrapper}
                />
                <Route
                  exact={true}
                  path={[INCIDENT_DETAIL_PATH, ":id", ":subform"].join("/")}
                  component={FormWrapper}
                />
                <Route
                  exact={true}
                  path={PRINT_PATH}
                  component={PrintPreviewComponent}
                />
                <Route
                  exact={true}
                  path={SP_FORM_PATH}
                  component={SpFormComponent}
                />
                
                <Route
                  exact={true}
                  path={USERS_PATH}
                  component={UserProfileComponent}
                />

                <Route
                  exact={true}
                 path={Dashboard_PATH + "/:id"}
                  component={PBIDashboardComponent}
                />
                
                <Route exact={true} path={ERROR_PATH} component={ErrorComponent} />
                <Route exact={true} path={ACCESS_REQUEST_PATH} component={AccessRequestComponent} />
              </Switch>
            </ContentWrapper>
            <div>
              <p>Build date: {getBuildDate(packageJson.buildDate)}</p>
            </div>
          </main>
        </div>)
        : (
          <React.Fragment>
            <div className={classes.root}>
              <CssBaseline />
              <Route component={Header} />
              <main className={classes.content}>
                <div className={classes.toolbar} />
                <ContentWrapper>
                  <Switch>
                    <Route exact={true} path={`${ACCESS_REQUEST_PATH}*`} component={AccessRequestComponent} />
                    <Route exact={true} path={ERROR_PATH} component={ErrorComponent} />
                    <Route exact={false} path={INTRO_PATH} component={IntroComponent} />
                    {/* {<Route path="*">
                      <Redirect to="/" />
                    </Route>} */}
                  </Switch>
                </ContentWrapper>
              </main>
            </div>
          </React.Fragment>
        )
      }
    </React.Fragment>
  );
}

const joinedStyles = (theme: Theme) =>
  createStyles({
    ...toolbarStyles(theme),
    ...headerStyles(theme),
  });

export default withStyles(joinedStyles)(RouterComponent);
